/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IApprove, IApproveInterface } from "../IApprove";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IApprove__factory {
  static readonly abi = _abi;
  static createInterface(): IApproveInterface {
    return new utils.Interface(_abi) as IApproveInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IApprove {
    return new Contract(address, _abi, signerOrProvider) as IApprove;
  }
}
